import { defineMessages } from "react-intl";

const baseId = "t.components.modals.PasswordModal.";

export default defineMessages({
  firstAccessTitle: {
    id: baseId + "firstAccessTitle",
    defaultMessage: "firstAccessTitle",
  },
  PasswordModalTitle: {
    id: baseId + "PasswordModalTitle",
    defaultMessage: "PasswordModalTitle",
  },
  PasswordModalDesc: {
    id: baseId + "PasswordModalDesc",
    defaultMessage: "PasswordModalDesc",
  },
  PasswordModalClose: {
    id: baseId + "PasswordModalClose",
    defaultMessage: "PasswordModalClose",
  },
  PasswordModalConfirm: {
    id: baseId + "PasswordModalConfirm",
    defaultMessage: "PasswordModalConfirm",
  },
  passwordPolicy: {
    id: baseId + "passwordPolicy",
    defaultMessage: "Password Policy: ",
  },
  labelChangePasswordField: {
    id: baseId + "labelChangePasswordField",
    defaultMessage: "New Password",
  },
  labelChangePasswordConfirmField: {
    id: baseId + "labelChangePasswordConfirmField",
    defaultMessage: "Confirm New Password",
  },
  checkLowerCase: {
    id: baseId + "checkLowerCase",
    defaultMessage: "Lowercase letters : {val}",
  },
  checkMaxLength: {
    id: baseId + "checkMaxLength",
    defaultMessage: "Max length : {val}",
  },
  checkMinLength: {
    id: baseId + "checkMinLength",
    defaultMessage: "Min length : {val}",
  },
  checkNumber: {
    id: baseId + "checkNumber",
    defaultMessage: "Required numbers : {val}",
  },
  checkSpecialChar: {
    id: baseId + "checkSpecialChar",
    defaultMessage: "Required special chars (min: {val1}) : {val2}",
  },
  checkUpperCase: {
    id: baseId + "checkUpperCase",
    defaultMessage: "Uppercase letters : {val}",
  },
  checkSamePassword: {
    id: baseId + "checkSamePassword",
    defaultMessage: "Same passwords",
  },
  errorPassword: {
    id: baseId + "errorPassword",
    defaultMessage: "errorPassword Title",
  },
  errorPasswordContent: {
    id: baseId + "errorPasswordContent",
    defaultMessage: "errorPasswordContent",
  },
});
